import React, { Component } from "react";
import {
    Button,
    Segment,
    Form,
    TextArea,
    Checkbox,
    Label,
} from "semantic-ui-react";
import moment from "moment";

class Notes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newNote: "",
            newNotePinned: false,
        };
    }

    onChangeNewNote(value) {
        this.setState({ newNote: value });
    }

    onChangeNewNotePinned() {
        this.setState({ newNotePinned: !this.state.newNotePinned });
    }

    save() {
        this.setState({ newNote: "", newNotePinned: false });
        this.props.save(this.state.newNote, this.state.newNotePinned);
    }

    list() {
        return this.props.notes.map((note, index) => {
            return (
                <Segment vertical key={index}>
                    <div className='row'>
                        <div className='col-sm-12 col-md-9'>
                            {note.pinned === true && (
                                <Label color='yellow mr-3'>Pinned</Label>
                            )}
                            <span>
                                <b>{note.createdBy.name}</b>
                            </span>
                            <span className='ml-3'>
                                {moment(note.createdAt).fromNow()}
                            </span>
                        </div>
                        <div className='col-xs-12 col-md-3 text-right d-flex align-items-center justify-content-end'>
                            {note.pinned === true && (
                                <Button
                                    primary
                                    className='theme'
                                    onClick={() =>
                                        this.props.unpinNoteCheck(
                                            note._id,
                                            false,
                                        )
                                    }
                                >
                                    Unpin
                                </Button>
                            )}
                            {note.pinned === false && (
                                <Button
                                    primary
                                    className='theme'
                                    onClick={() =>
                                        this.props.pinnedNoteToggle(
                                            note._id,
                                            true,
                                        )
                                    }
                                >
                                    Pin
                                </Button>
                            )}
                            {note.pinned === false && (
                                <Button
                                    primary
                                    className='theme red'
                                    onClick={() =>
                                        this.props.deleteNoteCheck(note._id)
                                    }
                                >
                                    Delete
                                </Button>
                            )}
                        </div>
                    </div>
                    <p className='mt-3' style={{ whiteSpace: "pre-line" }}>
                        {note.note}
                    </p>
                </Segment>
            );
        });
    }

    render() {
        return (
            <>
                <Segment vertical>
                    <Form className='mb-3'>
                        <div className='row'>
                            <div className='col-sm-12 col-md-6'>
                                <TextArea
                                    value={this.state.newNote}
                                    placeholder={
                                        "Add a note about " +
                                        this.props.user.name
                                    }
                                    onChange={({ target }) =>
                                        this.onChangeNewNote(target.value)
                                    }
                                />
                            </div>
                            <div className='col-xs-12 col-md-4 text-right d-flex align-items-center justify-content-end'>
                                <label className='with-input mr-3'>
                                    Pin note to top of list & display on their
                                    internal profile?
                                </label>
                                <Checkbox
                                    toggle
                                    name='primary'
                                    label={
                                        this.state.newNotePinned ? "Yes" : "No"
                                    }
                                    checked={this.state.newNotePinned}
                                    onChange={() =>
                                        this.onChangeNewNotePinned()
                                    }
                                />
                            </div>
                            <div className='col-xs-12 col-md-2 text-right d-flex align-items-center justify-content-end'>
                                <Button
                                    primary
                                    className='theme mt-3'
                                    onClick={() => this.save()}
                                    disabled={this.state.newNote.length === 0}
                                >
                                    Add{" "}
                                    {this.state.newNotePinned ? "pinned" : ""}{" "}
                                    note
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Segment>
                <h2>Member Notes</h2>
                {this.list()}
            </>
        );
    }
}

export default Notes;
